/**
 * boardHash — a stable, opaque board fingerprint for analytics events.
 *
 * Used by board_snapshot (§1.5) and template_selected (§1.7) to identify
 * board compositions without including PII or large payloads.
 *
 * Format: "h{tileCount}_{sortedTypes[:40]}"
 * This is order-insensitive for identical boards and lightweight enough to be
 * computed on every board mutation without performance concern.
 *
 * Shared utility: exported from analytics/ so both OnboardingBar and App.tsx
 * import the same implementation (DRY; avoids divergence).
 *
 * Immutability: pure function, returns a new string, never mutates input.
 */
import type { Board } from 'briefpane/schema';

/** Compute a stable, opaque hash for a board's composition. Pure. */
export function boardHash(board: Board): string {
  const types = [...board.tiles].map((t) => t.type).sort().join(',');
  return `h${board.tiles.length}_${types.substring(0, 40)}`;
}
